import { ApiService } from './api.service';
import { DashboardInfo } from '@/models/dashboard-info';
class SettingService extends ApiService {
  constructor() {
    super();
  }

  /**
   * ダッシュボードのお知らせ内容取得
   */
  getDashboardInfo(): Promise<DashboardInfo> {
    return this.get(DashboardInfo, `/dashboardInfo`, {});
  }
}

export const settingService = new SettingService();
